import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"

import { FieldError } from '../../../../../widgets'
import { IEntity } from "../../../../../base/types"
import { INumberProps } from './INumberProps'
import clsx from 'clsx'
import { useFormContext } from "../../form"
import { useFormikContext } from "formik"
import { useNumberValidationSchema } from './NumberValidationSchema'

interface INumberFieldProps extends HTMLAttributes<HTMLInputElement>, INumberProps {
    name: string
}

export const NumberField: FC<INumberFieldProps> = (props) => {
    const { id, name, placeholder, className, readOnly, disabled } = props
    const shape = useNumberValidationSchema(props)
    const { getFieldProps, errors, touched } = useFormikContext<IEntity>() || {}
    const { updateSchema } = useFormContext()

    useEffect(() => {
        if (!name || !shape) return;

        const schema = Yup.object().shape({ [name]: shape });
        updateSchema(schema);

        // eslint-disable-next-line
    }, [name, shape])

    let fieldProps = name ? getFieldProps(`['${name}']`) : { value: '' }
    if (fieldProps.value === undefined)
        fieldProps = { ...fieldProps, value: '' }

    return <>
        <input
            type='number'
            id={id}
            {...fieldProps}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
        />
        <FieldError show={touched[name] && !!errors[name]} message={`${errors[name]}`} />
    </>
}